import styled from 'styled-components';

const LoaderContainer = styled.div`
  margin: 0 auto;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default LoaderContainer;
